<div
	fxLayout="column"
	fxLayoutAlign="start start"
	class="footer_header"
	ngClass.lt-sm="m-t-m"
>
	<span
		i18n="@@footer_label_products"
		class="footer-titles mat-headline-6 product p-l-xs"
	>
		Product
	</span>
	<a
		i18n="@@footer_label_products_whydonatePlatform"
		[href]="crowdFundingHref"
		class="platform break-word"
		style="cursor: pointer"
		>Whydonate Platform
	</a>
	<a
		i18n="@@footer_label_donateButtonPlugin"
		[href]="donationButtonHref"
		class="donate break-word"
		style="cursor: pointer"
	>
		Donate Button Plugin
	</a>
	<!-- <a
		i18n="@@footer_label_digitalPinBox"
		[href]="digitalCollectionHref"
		class="digital"
		style="cursor: pointer"
	>
		Digital Pin Box
	</a> -->
</div>
